<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path id="Vector" d="M18.8131 7.51406C18.9324 7.6346 19 7.79732 19 7.96808V20.3571C19 20.7127 18.7156 21 18.3636 21H5.63636C5.28437 21 5 20.7127 5 20.3571V3.64286C5 3.28728 5.28437 3 5.63636 3H14.0821C14.2511 3 14.4142 3.0683 14.5335 3.18884L18.8131 7.51406ZM17.5324 8.26339L13.7898 4.48259V8.26339H17.5324Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path id="Vector_2" d="M14.4091 13.7969L11.7962 16.7906C11.3656 17.284 10.6117 17.2969 10.165 16.8187L8.55742 15.0977L6.7818 17.1276C6.14718 17.8531 6.654 19 7.60923 19H16.3908C17.3366 19 17.8469 17.8726 17.2313 17.1429L14.4091 13.7969Z" fill="#FFFFFF"/>
		<path id="Vector_3" d="M10.6794 11.6875C10.6794 12.6195 9.93588 13.375 9.01876 13.375C8.10163 13.375 7.35815 12.6195 7.35815 11.6875C7.35815 10.7555 8.10163 10 9.01876 10C9.93588 10 10.6794 10.7555 10.6794 11.6875Z" fill="#FFFFFF"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
